import RecommendCard from "@/components/base/RecommendCard";
import SectionHeading from "@/components/base/SectionHeading";
import type { Article } from "@/mocks/articles";

interface HotRecommendationsProps {
  articles: Article[];
}

export default function HotRecommendations({ articles }: HotRecommendationsProps) {
  return (
    <section aria-label="热门影视推荐">
      <SectionHeading
        eyebrow="TRENDING"
        icon="ri-fire-fill"
        title="热门影视推荐"
        description="根据站内浏览量整理的高热度作品，涵盖电影、剧集与纪录片。"
        actionTo="/category/recommendations"
        actionLabel="更多推荐"
      />
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        {articles.map((article) => (
          <RecommendCard key={article.id} article={article} />
        ))}
      </div>
    </section>
  );
}